import styles from "./Navbar.module.css";
import { useAuth } from "../../hooks";

export const Navbar = ({ toggleSidebar, setToggleSidebar }) => {
  const { isUserLoggedIn, userName } = useAuth();

  return (
    <nav>
      <div className={styles.navigation}>
        <div className={styles.logoIconWrapper}>
          <div
            className="icon"
            style={{ fill: "white", width: "38px", height: "38px" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="0 0 100 125"
              enableBackground="new 0 0 100 100"
            >
              <switch>
                <foreignObject
                  requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
                  x="0"
                  y="0"
                  width="1"
                  height="1"
                />
                <g>
                  <path d="M92.5,28.8c-0.8-1.5-2.7-2.2-4.2-1.4c-1.5,0.8-2.2,2.7-1.4,4.2c2.9,5.7,4.3,11.8,4.3,18.4s-1.5,12.7-4.3,18.4     c-0.8,1.5-0.2,3.4,1.4,4.2c0.5,0.2,0.9,0.3,1.4,0.3c1.1,0,2.2-0.6,2.8-1.7c3.3-6.6,5-13.7,5-21.2S95.8,35.4,92.5,28.8z" />
                  <path d="M11.7,27.4c-1.5-0.8-3.4-0.2-4.2,1.4c-3.3,6.6-5,13.7-5,21.2s1.7,14.6,5,21.2c0.5,1.1,1.6,1.7,2.8,1.7     c0.5,0,0.9-0.1,1.4-0.3c1.5-0.8,2.2-2.7,1.4-4.2C10.2,62.7,8.7,56.5,8.7,50s1.5-12.7,4.3-18.4C13.8,30.1,13.2,28.2,11.7,27.4z" />
                  <path d="M75.7,33.7c-1.5,0.8-2.2,2.7-1.4,4.2c1.9,3.8,2.9,7.8,2.9,12.1s-1,8.3-2.9,12.1c-0.8,1.5-0.2,3.4,1.4,4.2     c0.5,0.2,0.9,0.3,1.4,0.3c1.1,0,2.2-0.6,2.8-1.7c2.3-4.6,3.5-9.7,3.5-14.9c0-5.2-1.2-10.3-3.5-14.9C79.1,33.6,77.2,33,75.7,33.7z     " />
                  <path d="M24.3,33.7c-1.5-0.8-3.4-0.2-4.2,1.4c-2.3,4.6-3.5,9.7-3.5,14.9s1.2,10.3,3.5,14.9c0.5,1.1,1.6,1.7,2.8,1.7     c0.5,0,1-0.1,1.4-0.3c1.5-0.8,2.2-2.7,1.4-4.2c-1.9-3.8-2.9-7.8-2.9-12.1s1-8.3,2.9-12.1C26.5,36.4,25.9,34.5,24.3,33.7z" />
                  <path d="M50,30.7c-10.6,0-19.3,8.7-19.3,19.3S39.4,69.3,50,69.3S69.3,60.6,69.3,50S60.7,30.7,50,30.7z M56.4,51l-8.9,5.9     c-0.8,0.5-1.8,0-1.8-1V44.1c0-0.9,1-1.5,1.8-1l8.9,5.9C57,49.5,57,50.5,56.4,51z" />
                </g>
              </switch>
            </svg>
          </div>
          <div className={styles.title}>PlayStream</div>
        </div>
        <div className={styles.nameToggleWrapper}>
        {isUserLoggedIn && <div>Hi {userName}</div>}
        <div
          className={`icon ${styles.toggleIcon}`}
          onClick={() => setToggleSidebar((prev) => !prev)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1250"
            enableBackground="new 0 0 1000 1000"
          >
            <path d="M876.5,662.5" />
            <g>
              <g>
                <path d="M252.542,363.625h504.917c19.604,0,35.5-15.912,35.5-35.5c0-19.622-15.896-35.5-35.5-35.5H252.542    c-19.605,0-35.5,15.878-35.5,35.5C217.042,347.713,232.937,363.625,252.542,363.625z" />
              </g>
              <g>
                <path d="M757.459,452.236H252.542c-19.605,0-35.5,15.913-35.5,35.5c0,19.622,15.895,35.5,35.5,35.5h504.917    c19.604,0,35.5-15.878,35.5-35.5C792.959,468.149,777.063,452.236,757.459,452.236z" />
              </g>
              <g>
                <path d="M757.459,611.883H252.542c-19.605,0-35.5,15.878-35.5,35.5c0,19.587,15.895,35.5,35.5,35.5h504.917    c19.604,0,35.5-15.913,35.5-35.5C792.959,627.761,777.063,611.883,757.459,611.883z" />
              </g>
            </g>
          </svg>
        </div>
        </div>
      </div>
    </nav>
  );
};
